export const SIDEBAR_WIDTH=400;